module.exports = __webpack_public_path__ + "static/media/img01.0fada37d.webp";